<script lang="ts">
  import { storyblokEditable } from "@storyblok/svelte";

  import type { BlogPostStoryblok } from "~/component-types-sb"; // TODO: probably should include this in tsconfig types instead (it is a d.ts file)
  import { BlogCard } from '../../../../components';

  const { blok }: { blok: BlogPostStoryblok } = $props();

  const blogCardProps = {
    title: blok.meta_title ?? '',
    description: blok.meta_description ?? '',
    imageUrl: blok.image?.filename ?? undefined,
    imageAlt: blok.image?.alt ?? undefined,
    author: blok.author,
    categories: blok.category.map(cat => typeof cat === 'string' ? cat : cat.name),
    slug: blok.slug || '',
    publishedAt: blok.publishedAt,
  };
</script>

<BlogCard use={[[storyblokEditable, blok]]} {...blogCardProps} />
